// Module
var code = `<div class="modal-header"><h3 class="modal-title">Information</h3></div><div class="modal-body" class=".pre-line-white-space">{{vm.message}}</div><div class="modal-footer"><button class="btn btn-normal" ng-click="vm.close()">Close</button></div>`;
// Exports
export default code;